import {Cureus} from '../Cureus';

Cureus.Categories = {};

//= require_tree ./Categories
